import {
    initializeMailvistaAuth,
    MailvistaSDK,
    restoreConsoleCategories,
    TARGET_API_V2,
} from "@cs_teamwaydev/mailvista-sdk_react";
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import ErrorBoundary from "./components/ErrorBoundary";
import "./i18n";
import { setupTauriLinkBridge } from "./lib/tauriLinkBridge";
import routes from "./router/routes";
import "./index.css";
import "./styles/globals.css";

// Install the Tauri window bridge before anything else.
setupTauriLinkBridge();

restoreConsoleCategories();

// async wrapper to allow using async/await at the top level
async function startApp() {
    const root = document.getElementById("root");

    if (!root) {
        throw new Error("Missing root element");
    }

    // if (!import.meta.env.VITE_APP_GOOGLE_MAPS_API_KEY) { // To uncomment when using google maps
    //     throw new Error('Missing Google Maps API key');
    // }

    const { ...props } = root.dataset;

    const environment = import.meta.env.VITE_APP_ENVIRONMENT;

    let apiBackendTarget: TARGET_API_V2;

    switch (environment) {
        case "production":
            apiBackendTarget = TARGET_API_V2.Api_Prod;
            break;
        case "recette":
            apiBackendTarget = TARGET_API_V2.Api_Recette;
            break;
        case "local":
            apiBackendTarget = TARGET_API_V2.Api_Local;
            break;
        default:
            apiBackendTarget = TARGET_API_V2.Api_Dev;
            break;
    }

    await initializeMailvistaAuth({
        apiTarget: apiBackendTarget,
        publicUrls: [routes.success, routes.cancel, routes.notFound],
    });

    // Step-based assistant contract (Api-Ai docs/contrat-etapes.md): enabled on every environment
    // (/ai/conversation-etapes, BK-E1). The v1 contract is only kept as the SDK default.
    const conversationContract = "etapes";

    // No `clientInfo` yet (F-1.24): the X-Mv-Client / X-Mv-Trace-Id headers stay off on web and
    // desktop until the Api-Backend allows them in CORS (BK-1.3, T1-FR-29) — the browser would
    // otherwise block every call.
    ReactDOM.createRoot(root).render(
        <React.StrictMode>
            <ErrorBoundary>
                <MailvistaSDK
                    apiBackendTarget={apiBackendTarget}
                    conversationContract={conversationContract}
                >
                    <App {...props} />
                </MailvistaSDK>
            </ErrorBoundary>
        </React.StrictMode>,
    );
}

startApp().catch((error) => {
    console.error("Failed to start the app:", error);
});
